import { Styles, generateClasses } from 'netline-ui';

export const userProfileMenuClasses = generateClasses('UserProfileMenu', ['root', 'menuItem'] as const);

const styles: Styles = ({ theme: { palette } }) => ({
  [`.${userProfileMenuClasses.menuItem}`]: {
    display: 'flex',
    justifyContent: 'center',
    color: palette.grey[900],
    alignItems: 'center',
    alignSelf: 'stretch',
    fontWeight: 500,
  },
});

export default styles;
